import request from './request'

// 1. 企业认证输入
export const getCertification = (data) =>
	request({
		url: '/api/login/business/verify/submit',
		method: 'post',
		data,
	})

// 2. 企业认证（在职证明模板下载）
export const getDownload = (data) =>
	request({
		url: '/api/login/business/emp/template/download',
		method: 'post',
		data,
		responseType: 'blob', // 关键：必须设为 blob
		headers: {
			'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
		}
	})

// 3. 企业认证（在职证明认证）
export const getBind = (data) =>
	request({
		url: '/api/login/business/emp/bind/relation',
		method: 'post',
		data
	})